import React from 'react';

interface SsrSvgProps {
  component: React.ReactNode;
  height?: number;
  width?: number;
}
//The reason for this component is to render the svg on the server side
// to avoid the flickering of the svg when the page is loaded
const SsrSvg = ({ component, height = 24, width = 24 }: SsrSvgProps) => {
  return <div style={{ width, height }}>{component}</div>;
};

export default SsrSvg;
